export function guidEqual(guid1, guid2) {

    if((typeof guid1 === 'string') && (typeof guid2 === 'string')){
        guid1 = guidNormal(guid1);
        guid2 = guidNormal(guid2);
        return guid1 === guid2;
    }
    return false;
}

export function guidNormal(guid1) {
    if(typeof guid1 === 'string') {
        guid1 = guid1.toLowerCase().replace(/[{}]/g, '').replace('%7b', '').replace('%7d', '');
    }
    return guid1;
}
